<mat-toolbar class="subtitulo">Turmas</mat-toolbar>
<div class="painel-principal" style="padding: 10px;">
    <div class="painel-consultar">
        <form #formConsultar="ngForm">
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="16px" fxFlexFill>

                <mat-icon>search</mat-icon>
                <mat-form-field fxFlex="100%" fxFlexOffset="20px">
                    <mat-label>Selecione uma turma</mat-label>
                    <mat-select [(ngModel)]="turma" name="turma">
                        <mat-option></mat-option>
                        <mat-option *ngFor="let d of turmas" [value]="d">
                            {{d.descricao}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>


            <div dir="rtl" class="botoes" fxLayoutGap="20px" style="padding-top: 20px; padding-bottom: 20px;"
                fxFlexFill>

                <button mat-raised-button fxFlex="20%" (click)="consultar()">
                    CONSULTAR
                </button>

                <button mat-raised-button fxFlex="20%" style="padding-right: 20px" (click)="limpar()" route>
                    LIMPAR
                </button>

            </div>
        </form>

        <table *ngIf="mostrarTabela; else tabelaSemDados" mat-table [dataSource]="dataSource" style="margin-top: 20px">


            <ng-container matColumnDef="descricao">
                <th mat-header-cell *matHeaderCellDef> Descrição </th>
                <td mat-cell *matCellDef="let element" style="width: 25%;"> {{element.descricao}} </td>
              </ng-container>

              <ng-container matColumnDef="dataPrevisaoInicio">
                <th mat-header-cell *matHeaderCellDef> Data de Previsão de Início  </th>
                <td mat-cell *matCellDef="let element"> {{element.dataPrevisaoInicio | dataSimples}} </td>
              </ng-container>

              <ng-container matColumnDef="programa">
                <th mat-header-cell *matHeaderCellDef> Programa  </th>
                <td mat-cell *matCellDef="let element" style="width: 20%;"> {{element.programa?.nome}} </td>
              </ng-container>

              <ng-container matColumnDef="projeto">
                <th mat-header-cell *matHeaderCellDef> Projeto  </th>
                <td mat-cell *matCellDef="let element" style="width: 20%;"> {{element.projeto?.nome}} </td>
              </ng-container>

              <ng-container matColumnDef="acoes">
                <th mat-header-cell *matHeaderCellDef> Ações </th>
                <td mat-cell *matCellDef="let element">
                    <button *ngIf="perfilAcesso.deleta"  mat-button (click)="deletar(element)">
                        <mat-icon>delete</mat-icon>
                    </button>
                    <button *ngIf="perfilAcesso.consulta" mat-button (click)="atualizar(element)">
                        <mat-icon>search</mat-icon>
                    </button>
                </td>
            </ng-container>


            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
        <div [hidden]="!mostrarTabela">
            <mat-paginator [pageSizeOptions]="[20, 40, 60, 80 , 100]" showFirstLastButtons></mat-paginator>
        </div>
        <ng-template #tabelaSemDados>
            <div fxLayout="row" fxLayoutAlign="center center" style="padding-top: 20px">
                {{msg}}
            </div>
        </ng-template>

        <div fxLayout="row" *ngIf="perfilAcesso.insere" fxLayoutAlign="end center" fxLayoutGap="16px" style="padding-top: 50px">
            <div>
                <button matTooltip="Adicionar nova turma" mat-fab color="primary"
                    [routerLink]="menu ? ['/', menu, 'turmas', 'cadastrar'] : ['/turmas', 'cadastrar']"
                    routerLinkActive="router-link-active">
                    <mat-icon>add</mat-icon>
                </button>
            </div>
        </div>
    </div>
</div>
